import useUser from '@cobliteam/hooks/src/useEntity/useUser';
import Page from '@cobliteam/ui-business/components/layout/Page';
import PathAssociationTable from '../components/PathAssociationTable';
import FaceRecognitionBanner from '../components/PathAssociationTable/components/FaceRecognitionBanner';

const PathAssociationPage = () => {
  const { data: userData } = useUser().useGetUserData();
  const hasCameraFlag = userData?.hasCameraFlag;

  return (
    <Page>
      <Page.Header>
        <Page.Title />
      </Page.Header>

      <Page.Body>
        {hasCameraFlag && <FaceRecognitionBanner />}
        <PathAssociationTable />
      </Page.Body>
    </Page>
  );
};

export default PathAssociationPage;
